import api from './api';

const learningPathService = {
  // Documents
  uploadDocument: async (file, title) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    const response = await api.post('/learning-paths/documents/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  getDocuments: async () => {
    const response = await api.get('/learning-paths/documents/');
    return response.data;
  },

  getDocument: async (id) => {
    const response = await api.get(`/learning-paths/documents/${id}/`);
    return response.data;
  },

  // Learning Paths
  getLearningPaths: async () => {
    const response = await api.get('/learning-paths/paths/');
    return response.data;
  },

  getLearningPath: async (id) => {
    const response = await api.get(`/learning-paths/paths/${id}/`);
    return response.data;
  },

  startStep: async (pathId, stepId) => {
    const response = await api.post(
      `/learning-paths/paths/${pathId}/steps/${stepId}/start/`
    );
    return response.data;
  },

  submitStepQuiz: async (pathId, stepId, answers) => {
    const response = await api.post(
      `/learning-paths/paths/${pathId}/steps/${stepId}/submit-quiz/`,
      { answers }
    );
    return response.data;
  },
};

export default learningPathService;
